<template>
    <div class="LocationRecord">
        <div class="container-fluid">
            <div class="row">
                <div class="col col-md-12">
                    <button type="button" class="close" v-on:click="CloseRecord"><span>x</span></button>
                    <h1><span>{{ CareCommunityRecordData.Name }} </span></h1>

                </div>
            </div>
            <Summary v-bind:care-community-record-data="CareCommunityRecordData" />
        </div>
        <ActionButton v-if="CheckPermission('Administrator')"
                      class="DeleteButton"
                      :requires-confirmation="true"
                      confirmation-string="WARNING: You are about to delete this community care. This will also delete the families history with this care community. Are you sure you want to continue?"
                      endpoint="Foster/CareCommunity/DeleteCareCommunity"
                      :payload="{Id: CareCommunityRecordData.Id}"
                      :perform-global-update="true"
                      button-variant="danger"
                      button-string="DELETE CARE COMMUNITY RECORD"
                      button-size="md"
                      v-on:success="OnLocationDeleted"
                      style="position:fixed; bottom:40px;right:2vw; z-index:1000;" />
    </div>
</template>

<script>
    //import components
    //import Admin from "./Admin.vue";
    //import Information from "./Information.vue";
    //import People from "./People.vue";
    import Summary from "./Summary.vue";
    //import Reports from "./Reports.vue";
    import ActionButton from '../../../Core/ItemEditors/ActionButton.vue';
    import { EventBus } from '../../../../services/event-bus.js';
    export default {
        props: [
            'CareCommunityRecordData'
        ],
        created() {
            let vm = this;
            EventBus.$on('global-update-initiated', chartID => {
                if (chartID == vm.CareCommunityRecordData.Id) {
                    vm.UpdateChartData();
                }
            });

        },
        beforeDestroy() {
            EventBus.$off('global-update-initiated');
        },
        data: function () {
            return {
                PaneShown: "Summary",
                Panes: [
                    { name: 'Summary' },
                    //{ name: 'Team Info' },
                    //{ name: 'People' },
                    //{ name: 'Reports' }
                    //{ name: 'Admin' }
                ]
            };
        },
        methods: {
            UpdateChartData() {
                this.$MasterAPI.ExecuteRequest("GET", "Foster/CareCommunity/CareCommunity", { Id: this.CareCommunityRecordData.Id }, this.UpdateChartDataSuccess, () => { }, true);
            },
            UpdateChartDataSuccess(response) {
                this.$store.commit("CareCommunities.CareCommunityList.UpdateSingleRecord", response.data.data);
            },
            ChangePaneShown(paneName) {
                this.PaneShown = paneName;
            },
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            CloseRecord() {
                this.$parent.CloseRecord("CareCommunities.CareCommunityProfiles.Remove", "CareCommunityList", this.CareCommunityRecordData.Id);
            },
            OnLocationDeleted() {
                this.$parent.CloseRecord("CareCommunities.CareCommunityProfiles.Remove", "CareCommunityList", this.CareCommunityRecordData.Id);
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            //Admin,
            //Information,
            //People,
            Summary,
            ActionButton
            //Reports
        },
        mounted() {
        },
        computed: {
            changeDropdownName: function () {
                return this.PaneShown;
            },
        },
    }
</script>

<style scoped>
    .record-tabs {
        width: 100%;
        display: inline-block;
    }

    @media only screen and (max-width: 576px) {
        h4 {
            font-size: 1em;
        }

        h1 {
            font-size: 1.5em;
        }
    }

    li a {
        color: black !important;
    }

    li.active a {
        color: black !important;
    }
</style>